export default __webpack_public_path__ + "static/brand-13-bcc273fdaececa5fd0873e008155b698.png";